<template>
  <div>
    <div class="mb-8">
      <div class="flex items-center justify-start gap-8">
        <span
          class="cursor-pointer board__inactive"
          :class="{
            board__active: boardType === 'active',
          }"
          id="active"
          @click="boardType = 'active'"
        >
          <h4 class="text-lg w-fit whitespace-no-wrap">{{ $t('orgDashboard.userDashboard.boards.activeBoards') }}</h4>
        </span>

        <span
          class="hidden cursor-pointer board__inactive"
          :class="{
            board__active: boardType === 'paused',
          }"
          id="paused"
          @click="boardType = 'paused'"
        >
          <h4 class="text-lg w-fit whitespace-no-wrap">Paused</h4>
        </span>

        <span
          class="cursor-pointer board__inactive"
          :class="{
            board__active: boardType === 'deactivated',
          }"
          id="deactivated"
          @click="boardType = 'deactivated'"
        >
          <h4 class="text-lg w-fit whitespace-no-wrap">{{ $t('orgDashboard.userDashboard.boards.archived') }}</h4>
        </span>
      </div>
    </div>
    <div v-if="isBoardLoading">
      <vs-row
        class="px-4 py-4 rounded-lg grid flex-col lg:grid-cols-2 grid-cols-1 gap-6"
      >
        <vs-row
          v-for="i in 6"
          :key="i"
          class="p-24 rounded-lg my-2 bg-slate-300 animate-pulse"
        />
      </vs-row>
    </div>
    <div v-else class="py-4">
      <div
        class="grid flex-col lg:grid-cols-2 grid-cols-1 gap-6"
        v-if="userActiveBoards && userActiveBoards.length > 0"
      >
        <board-item-card
          v-for="(board, index) in userActiveBoards"
          :key="index"
          :boardData="board"
        />
      </div>
      <div v-else>
        <div
          class="flex flex-col p-4 gap-8 items-center w-full h-full justify-center py-8"
        >
          <img
            class="lg:w-3/12 w-64"
            src="@/assets/images/temp-img/empty-boards.svg"
          />
          <div class="flex flex-col gap-6 justify-center items-center">
            <p
              class="text-xl text-center flex gap-2 flex-col font-semibold text-black"
            >
              {{ $t('orgDashboard.userDashboard.boards.noBoards') }}
              <br />

              <span class="font-normal text-slate-600 text-base"
                >{{ $t('orgDashboard.userDashboard.boards.curate') }}</span
              >
            </p>
            <router-link
              to="/user/my-organizations"
              class="py-2 px-4 bg-primary text-slate-950 w-fit text-lg rounded-lg font-semibold"
              >{{ $t('orgDashboard.userDashboard.boards.goToOrg') }}</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BoardItemCard from "./components/BoardItemCard.vue";

export default {
  components: {
    BoardItemCard,
  },
  data() {
    return {
      userActiveBoards: [],
      isBoardLoading: true,
      boardType: "active",
    };
  },
  computed: {
    userLevelBoards() {
      return this.$store.state.boards.userLevelBoards;
    },
  },
  watch: {
    userLevelBoards: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.userActiveBoards = newVal && newVal.filter(
          (board) => board.boardData.status === this.boardType
        );
      },
    },
    boardType: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.userActiveBoards = this.userLevelBoards && this.userLevelBoards.length > 0 && this.userLevelBoards.filter(
          (board) => board.boardData.status === newVal
        );
      },
    },
  },
  mounted() {
    this.getUserBoards();
  },
  methods: {
    getUserBoards() {
      const userId = this.$store.state.auth.user._id;
      this.$store
        .dispatch("boards/fetchUserLevelBoards", userId)
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.isBoardLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.board {
  &__inactive {
    h4 {
      color: #5e5b5b !important;
      font-weight: 400;
    }
  }

  &__active {
    h4 {
      color: #101828 !important;
      font-weight: 600;
    }
  }
}
</style>
